/**
 * EN resource — Fulfillment module (P4). Keys mirror `vi/resources/vanHanh.ts`.
 */
export const vanHanh = {
  titles: {
    donHangList: 'All orders',
    tabDanhSach: 'Order list',
    tabGanNhanVien: 'Assign staff',
    xepNhat: 'Picking',
    kiemTra: 'Checking',
    dongGoi: 'Packing',
    dieuPhoi: 'Dispatching',
    giaoHang: 'Delivery',
    chiTietDon: 'Order detail',
    thongBao: 'Notification center',
  },
  fields: {
    xuLy: 'Process',
    viTri: 'Location',
    tieuDe: 'Title',
    kichThuoc: 'Dimensions',
    maHoaDon: 'Invoice code',
    khachHang: 'Customer',
    trangThai: 'Status',
    trangThaiVanHanh: 'Fulfillment status',
    chiNhanh: 'Branch',
    khachCanTra: 'Amount due',
    khachDaTra: 'Amount paid',
    conLai: 'Remaining',
    nguoiBan: 'Salesperson',
    nguoiNhanHang: 'Receiver',
    nguoiNhat: 'Picker',
    nguoiPhanCong: 'Assigned by',
    nguoiKiemTra: 'Checker',
    nguoiDongGoi: 'Packer',
    nguoiDieuPhoi: 'Dispatcher',
    nguoiShip: 'Shipper',
    thoiGian: 'Time',
    thoiGianPhanCong: 'Assigned at',
    thoiGianBatDau: 'Started at',
    thoiGianHoanThanh: 'Completed at',
    thoiGianNhan: 'Received at',
    soLuong: 'Quantity',
    soLuongDaNhat: 'Picked',
    soLuongDuKien: 'Expected',
    soLuongThucTe: 'Actual',
    chenhLech: 'Difference',
    tongSoKien: 'Total packages',
    thongTinKienChiTiet: 'Package details',
    anhChungTu: 'Evidence photos',
    ghiChu: 'Note',
    lyDo: 'Reason',
    maVanDon: 'Tracking code',
    soLanIn: 'Print count',
    cotIn: 'Print',
    nguonThayDoi: 'Change source',
    nguoiThucHien: 'Performed by',
    hanhDong: 'Actions',
    noiDung: 'Content',
    watched: 'Seen',
    chuaDoc: 'Unread',
    phuongThucBanGiao: 'Handover method',
    id: 'ID',
    giaoHangKiot: 'Kiot delivery',
    trangThaiDon: 'Order status',
    maDonHang: 'Order code',
    maKh: 'Customer code',
    nhanVienBanHang: 'Salesperson',
    sdtNhanVien: 'Staff phone',
    sslSp: 'Total qty',
    tongCan: 'Total weight',
    tongKhoi: 'Total volume',
    thoiCapNhat: 'Updated',
    xemSua: 'View / Edit',
    trangThaiGiaoHang: 'Delivery status',
    maKhachHang: 'Customer code',
    tenKhachHang: 'Customer name',
    ghiChuGiaoHang: 'Delivery note',
    soSanPham: 'Products',
    soLuongSanPham: 'Total quantity',
    tongCanNang: 'Total weight',
    tongTheTich: 'Total volume',
    diaChiGiaoHang: 'Delivery address',
    hanGiaoHang: 'Delivery deadline',
    doUuTien: 'Priority',
    tongTien: 'Total amount',
    ghiChuTrangThaiDon: 'Status note',
    thoiGianTao: 'Created date',
    thoiGianCapNhat: 'Updated date',
    ngayDatHang: 'Order date',
    hangVanChuyen: 'Carrier',
    phanCong: 'Assignment',
    maHangHoa: 'Product code',
    tenHangHoa: 'Product name',
    dienThoai: 'Phone',
    tenNguoiNhan: 'Receiver',
    sdtNguoiNhan: 'Receiver phone',
    tongTienHang: 'Subtotal',
    giamGia: 'Discount',
  },
  filters: {
    thongTinDonSection: 'Order info',
    phamViSection: 'Warehouse scope',
    phamViTatCa: 'All',
    phamViCuaToi: 'Only mine',
    hintSection: 'Fulfillment filters',
    hintBody: 'Filter orders by step status and assignee',
    search: 'Search invoice code / customer name',
    trangThai: 'Status',
    nguoiThucHien: 'Assignee',
    loaiThongBao: 'Notification type',
    chiNhanh: 'Branch',
    khoVatLy: 'Physical warehouse',
    khoVatLyTatCa: 'All physical warehouses',
    khoVatLyDaChon: '{count} warehouses',
    khoVatLyEmpty: 'No physical warehouse',
    tuNgay: 'From date',
    denNgay: 'To date',
    tatCa: 'All',
    maHoaDon: 'Invoice code',
    maKhachHang: 'Customer code',
    tenKhachHang: 'Customer name',
    maHangHoa: 'Product code',
    tenHangHoa: 'Product name',
    trangThaiGiaoHang: 'Delivery status',
    ngayDatHang: 'Order date',
    ngayTao: 'Created date',
    hanGiaoHang: 'Delivery deadline',
    nguoiBan: 'Salesperson',
    nguoiNhat: 'Picker',
    nguoiKiemTra: 'Checker',
    nguoiDongGoi: 'Packer',
    nguoiDieuPhoi: 'Dispatcher',
    nguoiShip: 'Shipper',
    thoiGianSection: 'Dates',
    nhanVienSection: 'Staff',
    nhanVienHint: 'Filter by step assignee',
  },
  placeholders: {
    search: 'Enter invoice code or customer name',
    lyDo: 'Enter reason',
    ghiChu: 'Enter note',
    thongTinKienChiTiet: 'E.g: Box 1: 5 shirts; Box 2: 3 pants',
    chonNhanVien: 'Select staff',
    maHoaDonMoi: 'Target invoice code/ID',
  },
  trangThaiVanHanh: {
    MOI: 'New',
    CHO_NHAT: 'Awaiting picking',
    DANG_NHAT: 'Picking',
    CHO_KIEM_TRA: 'Awaiting check',
    DANG_KIEM_TRA: 'Checking',
    CHO_DONG_GOI: 'Awaiting packing',
    DANG_DONG_GOI: 'Packing',
    CHO_DIEU_PHOI: 'Awaiting dispatch',
    DANG_DIEU_PHOI: 'Dispatching',
    CHO_GIAO_HANG: 'Awaiting delivery',
    DANG_GIAO_HANG: 'Delivering',
    GIAO_MOT_PHAN: 'Partially delivered',
    DA_GIAO_HANG: 'Delivered',
    GIAO_THAT_BAI: 'Delivery failed',
    DANG_GIAO_LAI: 'Redelivering',
    CHO_GIAO_LAI: 'Awaiting redelivery',
    HUY_DON: 'Cancelled',
  },
  // ===== 8 carrier delivery statuses (DHGiaoHangHoaDon) =====
  trangThaiVanDon: {
    CHO_XU_LY: 'Pending',
    CHO_LAY_HANG: 'Awaiting pickup',
    DANG_GIAO: 'Out for delivery',
    DA_GIAO: 'Delivered',
    PHAT_KHONG_THANH_CONG: 'Delivery failed',
    DANG_TRA_HANG: 'Returning',
    TRA_HANG: 'Returned',
    HUY: 'Cancelled',
  },
  trangThaiPhanCong: {
    DA_PHAN_CONG: 'Assigned',
    DANG_NHAT: 'Picking',
    HOAN_THANH: 'Done',
  },
  trangThaiKiemTra: {
    CHO_KIEM_TRA: 'Awaiting check',
    DANG_KIEM_TRA: 'Checking',
    HOAN_THANH: 'Done',
  },
  trangThaiDongGoi: {
    CHO_DONG_GOI: 'Awaiting packing',
    DANG_DONG_GOI: 'Packing',
    HOAN_THANH: 'Done',
  },
  trangThaiDieuPhoi: {
    CHO_DIEU_PHOI: 'Awaiting dispatch',
    DANG_DIEU_PHOI: 'Dispatching',
    HOAN_THANH: 'Done',
  },
  trangThaiDonShip: {
    CHO_GIAO_HANG: 'Awaiting delivery',
    DANG_GIAO_HANG: 'Delivering',
    DA_GIAO_HANG: 'Delivered',
    GIAO_MOT_PHAN: 'Partial',
    GIAO_THAT_BAI: 'Failed',
    CHO_GIAO_LAI: 'Awaiting redelivery',
    DANG_GIAO_LAI: 'Redelivering',
  },
  trangThaiThanhToan: {
    CHUA_TT: 'Unpaid',
    TT_MOT_PHAN: 'Partially paid',
    DA_TT: 'Paid',
  },
  nguonThayDoi: {
    USER: 'User',
    SYSTEM_JOB: 'System',
    API: 'API',
  },
  phuongThucBanGiao: {
    MANUAL: 'Manual',
    AUTO_SUGGEST: 'Auto suggest',
    QR_SCAN: 'QR scan',
  },
  loaiThongBao: {
    CODONHANGMOI: 'New order',
    CODONHANGCANNHAT: 'Pick needed',
    CODONHANGCANKIEMTRA: 'Check needed',
    CODONHANGCANDONGGOI: 'Pack needed',
    CODONHANGCANDIEUPHOI: 'Dispatch needed',
    CODONHANGCANGIAO: 'Delivery needed',
  },
  actions: {
    phanCongNhat: 'Assign picking',
    xemChiTiet: 'View detail',
    taoPhanCong: 'Create picking assignment',
    batDauNhat: 'Start picking',
    hoanThanhNhat: 'Complete picking',
    capNhatSoLuongNhat: 'Update picked quantity',
    thamGiaNhat: 'Join picking',
    xoaPhanCong: 'Delete assignment',
    batDauKiemTra: 'Start checking',
    luuKiemTra: 'Save check result',
    hoanThanhKiemTra: 'Complete checking',
    xoaKiemTra: 'Delete check',
    batDauDongGoi: 'Start packing',
    hoanThanhDongGoi: 'Complete packing',
    thamGiaDongGoi: 'Join packing',
    taiAnh: 'Upload photo',
    xoaAnh: 'Delete photo',
    xoaDongGoi: 'Delete packing',
    ganNguoiDieuPhoi: 'Assign dispatcher',
    batDauDieuPhoi: 'Start dispatching',
    hoanThanhDieuPhoi: 'Complete dispatching',
    thamGiaDieuPhoi: 'Join dispatching',
    xoaDieuPhoi: 'Delete dispatch',
    batDauGiao: 'Start delivery',
    giaoThanhCong: 'Delivered',
    giaoMotPhan: 'Partial delivery',
    giaoThatBai: 'Delivery failed',
    batDauGiaoLai: 'Start redelivery',
    ganLaiNguoiShip: 'Reassign shipper',
    thamGiaGiao: 'Join delivery',
    xoaDonShip: 'Delete delivery',
    resetDon: 'Reset order',
    overrideTrangThai: 'Force status',
    chuyenDoiLienKet: 'Relink workflow',
    inPhieuDongGoi: 'Print packing slip',
    inPhieuGiaoHang: 'Print delivery slip',
    in: 'Print',
    ganNhanVien: 'Assign staff',
    gan: 'Assign',
    xemLichSuNhat: 'View picking history',
    danhDauDaXem: 'Mark as seen',
    xemTatCaDaXem: 'Mark all as seen',
    xoaThongBao: 'Delete notification',
    choPhepThongBao: 'Enable push',
    lamMoi: 'Refresh',
  },
  messages: {
    loadError: 'Failed to load fulfillment list',
    batDauNhatThanhCong: 'Picking started',
    hoanThanhNhatThanhCong: 'Picking completed — check created',
    capNhatSoLuongThanhCong: 'Picked quantity updated',
    taoPhanCongThanhCong: 'Picking assignment created',
    capNhatPhanCongThanhCong: 'Picking assignment updated',
    xoaPhanCongThanhCong: 'Assignment deleted — order back to New',
    thamGiaThanhCong: 'Joined successfully',
    batDauKiemTraThanhCong: 'Checking started',
    luuKiemTraThanhCong: 'Check result saved',
    hoanThanhKiemTraThanhCong: 'Check completed — packing created',
    xoaKiemTraThanhCong: 'Check deleted',
    batDauDongGoiThanhCong: 'Packing started',
    capNhatDongGoiThanhCong: 'Packing updated',
    hoanThanhDongGoiThanhCong: 'Packing completed — dispatch created',
    xoaDongGoiThanhCong: 'Packing deleted',
    taiAnhThanhCong: 'Photo uploaded',
    xoaAnhThanhCong: 'Photo deleted',
    ganNguoiThanhCong: 'Staff assigned',
    batDauDieuPhoiThanhCong: 'Dispatching started',
    hoanThanhDieuPhoiThanhCong: 'Dispatching completed — delivery created',
    xoaDieuPhoiThanhCong: 'Dispatch deleted',
    batDauGiaoThanhCong: 'Delivery started',
    giaoThanhCongThanhCong: 'Delivery success recorded',
    giaoMotPhanThanhCong: 'Partial delivery recorded',
    giaoThatBaiThanhCong: 'Delivery failure recorded',
    giaoLaiThanhCong: 'Redelivery started',
    ganLaiShipThanhCong: 'Shipper reassigned',
    xoaDonShipThanhCong: 'Delivery deleted',
    resetThanhCong: 'Order reset',
    overrideThanhCong: 'Status forced',
    chuyenDoiLienKetThanhCong: 'Workflow relinked',
    danhDauDaXemThanhCong: 'Marked as seen',
    xoaThongBaoThanhCong: 'Notification deleted',
    chuaCoDuLieu: 'No data',
    chuaCoDuLieuKhopLoc: 'No data matches filters',
    canChonNhanVien: 'Please select at least one staff',
    canNhapLyDo: 'Please enter reason',
    canNhapSoKien: 'Please enter total packages',
    canNhapMaHoaDonMoi: 'Please enter target invoice',
    coWarnings: 'Action completed with warnings',
  },
  xacNhan: {
    batDauNhat: 'Start picking order {maHoaDon}?',
    hoanThanhNhat: 'Complete picking order {maHoaDon}? A check will be created.',
    xoaPhanCong: 'Delete picking assignment of {maHoaDon}? Order returns to New.',
    batDauKiemTra: 'Start checking order {maHoaDon}? You become the checker.',
    hoanThanhKiemTra: 'Complete checking order {maHoaDon}? A packing will be created.',
    xoaKiemTra: 'Delete check of {maHoaDon}? Order returns to Picking.',
    batDauDongGoi: 'Start packing order {maHoaDon}?',
    hoanThanhDongGoi: 'Complete packing order {maHoaDon}? A dispatch will be created.',
    xoaDongGoi: 'Delete packing of {maHoaDon}? Order returns to Checking.',
    batDauDieuPhoi: 'Start dispatching order {maHoaDon}?',
    hoanThanhDieuPhoi: 'Complete dispatching order {maHoaDon}? A delivery will be created.',
    xoaDieuPhoi: 'Delete dispatch of {maHoaDon}? Order returns to Packing.',
    batDauGiao: 'Start delivering order {maHoaDon}?',
    giaoThanhCong: 'Confirm SUCCESSFUL delivery of {maHoaDon}?',
    giaoMotPhan: 'Confirm PARTIAL delivery of {maHoaDon}?',
    giaoThatBai: 'Confirm FAILED delivery of {maHoaDon}?',
    giaoLai: 'Start redelivery of {maHoaDon}?',
    xoaDonShip: 'Delete delivery of {maHoaDon}? Order returns to Awaiting dispatch.',
    resetDon: 'Reset order {maHoaDon} to "{trangThai}"?',
    overrideTrangThai: 'Force status of {maHoaDon} to "{trangThai}"? Admin action — for corrupted data.',
    chuyenDoiLienKet: 'Move the whole workflow of {maHoaDon} to the target order? Current order will be CANCELLED.',
    xoaThongBao: 'Delete this notification?',
    xoaAnh: 'Delete this photo?',
  },
  xepNhat: {
    chuaPhanCongTitle: 'Invoices awaiting picking assignment',
    chuaPhanCongHint: 'New workflow orders without a picker',
    taoPhanCongTitle: 'Create picking assignment',
    capNhatPhanCongTitle: 'Update picking assignment',
    chonNguoiNhat: 'Pickers',
    chonDongHang: 'Order lines to pick',
    tatCaDong: 'All lines (default)',
    lichSuNhatTitle: 'Picking history',
    sttLan: 'Time',
    soLuongTangThem: 'Added quantity',
    daNhatDu: 'Enough',
    conThieu: 'Missing {so}',
    tieuDeForm: 'Picking — {maHoaDon}',
  },
  kiemTra: {
    tieuDeForm: 'Check — {maHoaDon}',
    hintDuKienVsThucTe: 'Enter actual quantity per line — differences are highlighted',
    dongDu: 'OK',
    dongThieu: 'Missing {so}',
    dongDuThua: 'Extra {so}',
    nguoiKiemTraHint: 'Whoever starts the check becomes the checker',
  },
  dongGoi: {
    tieuDeForm: 'Packing — {maHoaDon}',
    anhChungTuHint: 'Photos of packages (handover evidence)',
    phieuKhoLienKet: 'Linked stock vouchers',
  },
  dieuPhoi: {
    tieuDeForm: 'Dispatch — {maHoaDon}',
    phanNhanh: 'Branch',
    giaoNoiBo: 'Internal delivery',
    banGiaoHang: 'Hand over to carrier',
    banGiaoHangHint: 'Carrier orders: completing dispatch means handover — track via shipping module',
    nguoiShipKhiHoanThanh: 'Internal shippers (on completion)',
    chuaCoVanDon: 'No tracking code yet',
  },
  giaoHang: {
    tieuDeForm: 'Delivery — {maHoaDon}',
    ketQuaGiao: 'Delivery result',
    chiTietGiaoMotPhan: 'Delivered lines detail',
    soLuongGiaoLanNay: 'Attempt',
    soLuongGiao: 'Delivered qty',
    anhBangChung: 'Delivery evidence photos',
    thongTinGhiNhan: 'Delivery records',
    canNguoiShip: 'No shipper assigned — assign before starting',
  },
  chiTiet: {
    timeline: 'Status history',
    buoc: 'Step',
    buoc1: 'Picking',
    buoc2: 'Check',
    buoc3: 'Packing',
    buoc4: 'Dispatch',
    buoc5: 'Delivery',
    chuaCoBuoc: 'No data for this step yet',
    qrBanGiao: 'Handover QR',
    qrHint: 'Receiver scans to join their step',
    inPhieu: 'Print slip',
    trangThaiCu: 'From status',
    trangThaiMoi: 'To status',
    thongTinHoaDon: 'Invoice info',
    thongTinKhachHang: 'Customer info',
    thanhToan: 'Payment',
    cacBuoc: 'Processing steps',
  },
  flow: {
    tabThongTin: 'Order info',
    tabChiTiet: 'Order lines',
    tabFlow: 'Order flow',
    tieuDe: 'Order processing flow',
    moRongTatCa: 'Expand all',
    thuGonTatCa: 'Collapse all',
    buocDonMoi: 'New order',
    buocNhat: 'Picking',
    buocKiem: 'Checking',
    buocDongGoi: 'Packing',
    buocDieuPhoi: 'Dispatch',
    buocGiao: 'Delivery',
    ketThucNhat: 'Picking finished',
    ketThucKiemTra: 'Checking finished',
    ketThucDongGoi: 'Packing finished',
    ketThucDieuPhoi: 'Dispatch finished',
    nguoiThucHien: 'Performed by',
    buocHienTai: 'Current step',
    ghiChu: 'Note',
    tongSoKien: 'Total packages',
    ghiChuDongHang: 'Packing note',
    lichSu: 'Status change history',
    trangThaiHienTai: 'Current status',
    chuaCoLichSu: 'No status changes yet.',
    ghiChuDon: 'Order note',
    nguoiTao: 'Created by',
    hanGiaoHang: 'Delivery deadline',
    doUuTien: 'Priority',
    dienThoaiNhan: 'Recipient phone',
    doiTacGiaoHang: 'Delivery partner',
    buocXong: 'Done',
    buocDangLam: 'In progress',
    buocChuaToi: 'Pending',
    hienTai: 'Current',
    tienTrinh: 'Progress',
  },
  donHang: {
    sapXepTheoCot: 'Sorted by column',
    tongHopSanPham: 'Product summary',
    tongHopSanPhamTitle: 'Aggregated product list',
    tongHopSanPhamTom: '{soDon} orders · {soMa} SKUs · Qty: {soLuong}',
    tongHopSanPhamTrong: 'No product lines in the selected orders',
    sapXep: 'Sort',
    sapXepTheoMa: 'Code',
    sapXepTheoTen: 'Name',
    chiaTheoDon: 'Split by order',
    khongCoThaoTac: 'No actions',
    resetTitle: 'Reset order',
    khongCoTrangThaiReset: 'No valid status to reset this order to',
    donHuy: 'Cancelled order',
    overrideTitle: 'Force order status',
    chuyenDoiLienKetTitle: 'Relink order workflow',
    hoaDonMoiId: 'Target invoice',
    trangThaiMucTieu: 'Target status',
    warnings: 'Warnings',
    khongCoNguoi: '—',
    daGan: '{count} assigned',
    chuaGan: 'Not assigned',
    ganBuoc: 'Assign {buoc}',
    assignPicker: 'picker',
    assignInspector: 'checker',
    assignPacker: 'packer',
    assignDispatcher: 'dispatcher',
    assignShipper: 'shipper',
    ganNhanVienTitle: 'Assign staff ({count} orders)',
    ganNhanVienHint: 'Pick staff for the step matching selected order statuses',
    khacBuoc: 'Selected orders belong to a different step ({buoc}) — deselect or assign separately',
    inspectorHint: 'Check step has no pre-assignment — whoever starts the check takes it',
    nutNhat: 'Pick',
    nutDong: 'Pack',
    nutGiao: 'Deliver',
    nutDieuPhoi: 'Disp.',
    sapXepMacDinh: 'Priority (default)',
    sapXepNgayDatMoi: 'Order date — newest',
    sapXepNgayDatCu: 'Order date — oldest',
    sapXepTaoMoi: 'Created — newest',
    sapXepTaoCu: 'Created — oldest',
    sapXepHanXa: 'Deadline — farthest',
    sapXepHanGan: 'Deadline — nearest',
    xemDayDu: 'View full detail',
    khongTaiDuocChiTiet: 'Could not load order detail',
    thongTinGiao: 'Delivery info',
    daChonDon: 'Selected: {count} orders',
    soSanPhamTong: 'Products',
    soLuongSanPhanTong: 'Total quantity',
    tongCanNangChon: 'Total weight',
    tongTheTichChon: 'Total volume',
    boChon: 'Clear selection',
    ganDon: 'Assign orders',
    ghiDe: 'Override',
    chuyenWorkflow: 'Transfer workflow',
    bulkOverrideTitle: 'Bulk override status',
    bulkOverrideBoQua: 'Skipping {count} delivered / cancelled orders',
    lyDoOverride: 'Override reason',
    giaoThanhCongBtn: 'Mark delivered',
    giaoThatBaiBtn: 'Mark delivery failed',
    overrideHoanTat: 'Override finished: {ok}/{total} succeeded',
    choXuLy: 'Pending',
    thanhCong: 'Success',
    thatBai: 'Failed',
    khongCoDonHopLe: 'No eligible orders to override',
    transferTitle: 'Transfer order workflow',
    transferHint:
      'Cancels the SOURCE order workflow (source becomes cancelled) and moves the TARGET order to New. Both orders must share a branch; target must have no workflow yet.',
    transferNguonHint: 'This order workflow will be cancelled',
    transferDichHint: 'This order will move to New',
    donNguon: 'Source order',
    donDich: 'Target order',
    doiVaiTro: 'Swap source/target',
    can2Don: 'Select exactly 2 orders to transfer workflow',
    inPhieu: 'Print',
    inPhieuGiaoLogo: 'Delivery slip (with logo & address)',
    inPhieuGiaoToiGian: 'Delivery slip (minimal)',
    inPhieuDongGoiLogo: 'Packing slip (with logo & address)',
    inPhieuDongGoiToiGian: 'Packing slip (minimal)',
    chonMauIn: 'Choose template',
    nhomCoLogo: 'With logo & address',
    nhomKhongLogo: 'Without logo & address',
    nhomKhac: 'Other',
    mauIn: {
      PHIEU_GIAO_HANG_V1: 'Delivery slip V1',
      HOA_DON_BAN_HANG: 'Sales invoice V1',
      PHIEU_GIAO_HANG_V2: 'Delivery slip V2',
      HOA_DON_BAN_HANG_V2: 'Sales invoice V2',
      PHIEU_DONG_GOI: 'Packing slip',
    },
    inPhieuDaIn: 'Print (printed {count} time(s))',
    daTaoPhieuIn: 'Created {count} slips to print',
    boQuaDonHuy: 'Skipped {count} cancelled orders',
    xuatExcel: 'Export Excel',
    xuatExcelDon: 'Export order list Excel',
    xuatExcelChiTiet: 'Export item detail Excel',
    xuatExcelThanhCong: 'Excel export succeeded!',
    xuatExcelLoi: 'Excel export failed',
    fileExcelDon: 'Fulfillment order list',
    fileExcelChiTiet: 'Fulfillment order details',
    thuKhac: 'Other charges',
  },
  thongBao: {
    trungTam: 'Notification center',
    danhSach: 'Notifications',
    thongBaoChung: 'Broadcast',
    chuaXemTatCa: 'Mark all as seen',
    khongCoThongBao: 'No notifications',
    choPhepPush: 'Enable push on this device',
    pushDaBat: 'Push enabled',
    pushBiTuChoi: 'Browser denied notification permission',
    pushLoiCauHinh: 'Firebase not configured (REACT_APP_FIREBASE_*) — push disabled',
    diDenDon: 'Go to order',
  },
  in: {
    phieuDongGoi: 'PACKING SLIP',
    phieuGiaoHang: 'DELIVERY SLIP',
    chiNhanh: 'Branch',
    khachHang: 'Customer',
    nguoiBan: 'Salesperson',
    nguoiNhan: 'Receiver',
    nguoiDongGoi: 'Packed by',
    nguoiShip: 'Delivered by',
    chiTietHang: 'Item details',
    stt: 'No.',
    maHang: 'Code',
    tenHang: 'Name',
    soLuong: 'Qty',
    donVi: 'UOM',
    ghiChu: 'Note',
    tongCong: 'Total',
    thoiGianIn: 'Printed at',
    inLanThu: 'Print no.',
    khachCanTra: 'Amount due',
    khachDaTra: 'Amount paid',
    conLai: 'Remaining',
    trangThaiThanhToan: 'Payment',
    qrBanGiao: 'Scan handover QR',
    donVanDon: 'Tracking',
    ketQua: 'Result',
  },
  buoc: {
    gan: 'Assign',
    nhat: 'Pick',
    kiem: 'Check',
    dong: 'Pack',
    dieu: 'Dispatch',
    giao: 'Deliver',
    giaoLai: 'Redeliver',
    chiTiet: 'Detail',
  },
  aria: {
    moMenuThaoTac: 'Open action menu',
    xemChiTiet: 'View order detail',
    chonCotHienThi: 'Choose visible columns',
    moMenuSapXep: 'Open sort menu',
    moRongDong: 'Expand row detail',
    selectAllPage: 'Select all rows on this page',
    selectRow: 'Select row',
  },
  // ===== impl-c =====
  implC: {
    common: {
      xoa: 'Delete',
      tonKho: 'Stock',
    },
    xepNhat: {
      nhatDu: 'Pick all',
      datLai: 'Reset',
      viewerOnly: 'This order is being picked by {nguoi} — you have view-only access.',
      viewerOnlyKhongTen:
        'This order is assigned to another picker — you have view-only access.',
      daDuToanBo: 'All lines are already fully picked',
      daVeKhongToanBo: 'Picked quantities are already 0',
    },
    kiemTra: {
      kiemDu: 'Check all',
    },
    chiTietDon: {
      tabSanPham: 'Products',
      daKiem: 'Checked',
      kgThung: 'KG/box',
      m3Thung: 'M³/box',
      slThung: 'Qty/box',
      soThung: 'Boxes',
      kichThuoc: 'L×W×H',
      viTri: 'Location',
      tongCanNang: 'Total weight (kg)',
      tongTheTich: 'Total volume',
      mocCaoNhat: 'Highest workflow step',
      trangThaiHienTai: 'Current status',
      sheetName: 'Order item details',
      filePrefix: 'Order_items',
    },
    tongHopSp: {
      tieuDe: 'Aggregated product list',
      thongKe: '{soDon} orders · {soMa} product codes · Qty: {soLuong}',
      sapXep: 'Sort',
      ma: 'Code',
      ten: 'Name',
      chiaDon: 'Split by order',
      dangTai: 'Aggregating products…',
      khongCoDuLieu: 'No product details from the selected orders.',
    },
    gallery: {
      xem: 'View ({so} photos)',
      moTabMoi: 'Open image in new tab',
      truoc: 'Previous photo',
      sau: 'Next photo',
    },
    kien: {
      tabThongTin: 'Info',
      tabInPhieu: 'Print slips',
      danhSachKien: 'Package list',
      tong: '{so} packages',
      chan: 'Full',
      le: 'Partial',
      gop: 'Mixed',
      soKienVatLy: 'Packages',
      loai: 'Type',
      sanPham: 'Products',
      soLuongKien: 'Repeat count',
      taoGop: 'Create mixed package',
      goiYCoBan: 'Basic suggestion',
      goiYThongMinh: 'Smart suggestion',
      inA4: 'Print A4 slips',
      inA5: 'Print A5 slips',
      taoGopTieuDe: 'Create mixed package',
      daChon: 'Selected {chon}/{tong} products',
      slCo: 'Available',
      khongConSpGop: 'No products left to combine',
      taoGopThanhCong: 'Mixed package created!',
      can2Sp: 'A mixed package needs at least 2 products!',
      loiSl: 'Quantity exceeds available quantity:',
      loiSlChiTiet: '{ten}: requested {yeucau} but only {co} available',
      daLuu: 'Saved packages',
      xemTabInPhieu: 'edit in "Print slips" tab',
      phieuKien: 'PACKAGE SLIP',
      phieuKienGop: 'MIXED PACKAGE SLIP',
      kien: 'Package',
      ngay: 'Date',
      gio: 'Time',
      chuKy: 'Packer signature',
      maDon: 'Order code',
      daTaoTrang: 'Created {so} slip pages to print ({khogiay})!',
      chuaCoKien: 'No packages yet — click "Basic suggestion" to generate',
    },
    g18: {
      chuaCoPhieu: 'Order has no {buoc} record yet',
      xemPhieuDongGoi: 'Packing record',
      xemPhieuDieuPhoi: 'Dispatch record',
      xemDonShip: 'Delivery record',
      bulkGiao: 'Deliver',
      bulkDieuPhoi: 'Dispatch multiple orders',
    },
    g19: {
      tabThongTinDon: 'Order info',
      tabFlowDon: 'Order flow',
      thongTinCoBan: 'Basic information',
      nguoiTao: 'Created by',
      buocDonMoi: 'New order',
      moTa: 'Description',
      trangThaiCaoNhat: 'Highest status the order has reached',
      lichSuThayDoi: 'Status change history',
      moRongTatCa: 'Expand all',
      thuGonTatCa: 'Collapse all',
      moRong: 'Expand',
      thuGon: 'Collapse',
      anh: 'Photo',
      ghiChuSp: 'Item note',
      chuaCo: 'Not yet',
      khongCoGhiChu: 'No note',
    },
  },
  // ===== impl-a =====
  implA: {
    ganTuanTuHint: 'Selected orders share the same status. The system processes them one by one — no need to switch working branch.',
    logDangXuLy: '… {ma}: processing',
    logOk: '✓ {ma}: done',
    logLoi: '✗ {ma}: {msg}',
    loiChung: 'Error',
    ketQuaHonHop: 'Assigned {ok} orders, {fail} failed: {loi}',
    thatBaiHet: 'No order was processed successfully — see the log below',
    dangGan: 'Assigning…',
    dieuPhoiNhieuDon: 'Bulk dispatch',
    dieuPhoiNhieuDonTitle: 'Dispatch multiple orders ({count})',
    dieuPhoiAutoChainHint: 'For each pending / dispatching order: Join → Start → Complete (with shipper). Ineligible orders are skipped.',
    dieuPhoiBoQua: 'Skipped {count} orders not in pending / dispatching status',
    dieuPhoiKhongHopLe: 'No eligible orders to dispatch (pending / dispatching)',
    nguoiGiaoLabel: 'Shippers',
    ghiChuDieuPhoi: 'Dispatch note (applied on completion)',
    batDauDieuPhoi: 'Start dispatch',
    dangDieuPhoi: 'Dispatching…',
    dieuPhoiKetQua: 'Dispatched {ok}/{total} orders, {fail} failed',
    giaoNhieuDon: 'Bulk delivery',
    giaoNhieuDonTitle: 'Bulk delivery ({count} orders)',
    giaoAutoChainHint: 'For each order: join the delivery record (if needed) → start delivery → finish with the selected result. Photos and notes apply to all selected orders.',
    giaoBoQua: 'Skipped {count} ineligible orders (no delivery record or unsuitable status)',
    giaoKhongHopLe: 'No eligible orders (missing delivery record or unsuitable status)',
    giaoHoanThanh: 'Delivered',
    giaoMotPhan: 'Partially delivered',
    giaoThatBai: 'Failed',
    ghiChuGiaoMotPhan: 'Partial delivery note',
    ghiChuGiaoThanhCong: 'Successful delivery note',
    ghiChuGiaoThatBai: 'Failure reason / note',
    anhGiaoChung: 'Delivery photos (pick once — uploaded separately per order)',
    canLyDoGiaoThatBai: 'A failure reason is required',
    thucHien: 'Run',
    dangGiao: 'Delivering…',
    giaoKetQua: 'Processed {ok}/{total} orders, {fail} failed',
    tuyChon: 'Optional',
    xuatExcelCotHienThi: 'Export Excel (visible columns)',
    soLanInHint: 'Printed {count} time(s)',
    lichSuTrangThai: 'Status history',
    chuaCoLichSu: 'No status history',
    trangThaiCaoNhatNguon: 'Highest status the source order reached',
    dichSeVaoMoi: 'the target order will become New (MOI)',
    assignScopeTatCa: 'All',
    assignScopeChiToi: 'Mine only',
    assignScopeHint: 'Scope orders by the person currently holding the step',
    assignScopeAria: 'Staff scope',
    tongHopSp: 'Aggregate items',
    nhomHang: 'Item group',
    thoiGianTheoBuoc: 'Times per workflow step',
    buocNhat: 'Picking',
    buocKiemTra: 'Checking',
    buocDongGoi: 'Packing',
    buocDieuPhoi: 'Dispatching',
    buocGiaoHang: 'Delivery',
    tu: 'From',
    den: 'To',
    chiTietNhat: 'Picking detail',
    chuaCoPhanCongNhat: 'Order has no picking assignment — create one first',
    chiTietKiemTra: 'Checking detail',
    chuaCoPhieuKiemTra: 'Order has no check record (created when picking completes)',
  },
  // ===== be-vanhanh =====
  beVanHanh: {
    dieuPhoiView: {
      densityLabel: 'Row density',
      densityDefault: 'Normal',
      densityCompact: 'Compact',
      densityUltra: 'Ultra compact',
      tableViewLabel: 'Table layout',
      singleTable: 'Single table',
      splitTable: 'Split',
      zoomOut: 'Zoom out',
      zoomIn: 'Zoom in',
      zoomReset: 'Reset zoom to default (100%)',
      fullscreen: 'Fullscreen',
      fullscreenClose: 'Close',
      reset: 'Default',
      resetHint: 'Reset density, zoom and layout to defaults',
    },
  },
}
